var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('TopMenu',{attrs:{"sections":_vm.sections}}),_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"header__logo"},[_c('img',{staticClass:"header__logo--fix",attrs:{"src":require("../assets/logo_260_142.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }